import {EState} from '@app/state/reducers';
import {createFeatureSelector, createSelector} from '@ngrx/store';
import {IMaintenanceModeState} from '../models/maintenance-mode-state.model';

export const selectMaintenanceModeState = createFeatureSelector<IMaintenanceModeState>(EState.MaintenanceMode);
export const selectMaintenanceMode = createSelector(
  selectMaintenanceModeState,
  (state: IMaintenanceModeState) => state.isMaintenanceMode
);
